import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { Pagination, Role, SelectItem } from '~/types';
import { getInternalRoles, getRoles, getExternalRoles } from '~/services';
import { getInternalRolesWithoutAdministratorOrClient } from '~/services/Roles';

export function useRoles(
  options: UseQueryOptions<Pagination<Role>, unknown> = {},
): UseQueryResult<Pagination<Role>, unknown> {
  return useQuery<Pagination<Role>, unknown>(['roles'], () => getRoles(), {
    staleTime: 1000 * 60 * 10, // 10 minutes
    ...options,
  });
}

export function useInternalRoles(
  options: UseQueryOptions<Pagination<Role>, unknown> = {},
): UseQueryResult<Pagination<Role>, unknown> {
  return useQuery<Pagination<Role>, unknown>(
    ['internalRoles'],
    () => getInternalRoles(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useInternalRolesWithoutAdministrator(
  options: UseQueryOptions<SelectItem[], unknown> = {},
): UseQueryResult<SelectItem[], unknown> {
  return useQuery<SelectItem[], unknown>(
    ['internalRolesWithoutAdministrator'],
    () => getInternalRolesWithoutAdministratorOrClient(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useExternalRoles(
  options: UseQueryOptions<Pagination<Role>, unknown> = {},
): UseQueryResult<Pagination<Role>, unknown> {
  return useQuery<Pagination<Role>, unknown>(
    ['externalRoles'],
    () => getExternalRoles(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
